import { Navigate, useRoutes } from "react-router-dom";
import AgentsPage from "./agents";
import AuthenticationPage from "./authentication";
import BackendIntegrationPage from "./backend-integration";
import ChatApiPage from "./chat-api";
import CommoditiesPage from "./data-coverage/commodities";
import CryptoPage from "./data-coverage/crypto";
import EquitiesPage from "./data-coverage/equities";
import FundsPage from "./data-coverage/funds";
import IndicesPage from "./data-coverage/indices";
import FrontendIntegrationPage from "./frontend-integration";
import IntroductionPage from "./introduction";
import McpPage from "./mcp";
import NewsRpmApiPage from "./newsrpm-api";
import QuickstartPage from "./quickstart";
import RestApiPage from "./rest-api";
import RssFeedsPage from "./rss-feeds";
import SearchApiPage from "./search-api";

export default () =>
  useRoutes([
    { path: "", element: <IntroductionPage/> },
    { path: "quickstart", element: <QuickstartPage/> },
    { path: "authentication", element: <AuthenticationPage/> },
    { path: "rest-api", element: <RestApiPage/> },
    { path: "newsrpm-api", element: <NewsRpmApiPage/> },
    { path: "search-api", element: <SearchApiPage/> },
    { path: "chat-api", element: <ChatApiPage/> },
    { path: "mcp", element: <McpPage/> },
    { path: "agents", element: <AgentsPage/> },
    { path: "frontend-integration", element: <FrontendIntegrationPage/> },
    { path: "backend-integration", element: <BackendIntegrationPage/> },
    { path: "rss-feeds", element: <RssFeedsPage/> },
    { path: "data-coverage", element: <EquitiesPage/> },
    { path: "data-coverage/crypto", element: <CryptoPage/> },
    { path: "data-coverage/indices", element: <IndicesPage/> },
    { path: "data-coverage/funds", element: <FundsPage/> },
    { path: "data-coverage/commodities", element: <CommoditiesPage/> },
    { path: "*", element: <Navigate to="/docs"/> },
  ]);
